import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const cards = [
  {
    key: `Right-data-warehouse`,
    title: `How to choose the right data warehouse`,
    description: `Not only are there quite a few options on the market, but each has a slightly different set of features to consider. Visit our Analytics Academy to see which one is right for you.`,
    url: `/academy/choosing-stack/how-to-choose-the-right-data-warehouse/`,
  },
  {
    key: `Data-warehouse-analytics`,
    title: `Selecting the Right Data Warehouse for Analytics`,
    description: `Understand the six key elements to consider when selecting a data warehouse for analytics and dive into use cases best suited for top data warehouse providers.`,
    url: `https://learn.segment.com/data-warehouse-guide/`,
  },
]

const CardsSection: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSection variant="centered">
      <Section.Contents>
        <ColumnTrack columns={1} overrides={{ md: 2 }}>
          {cards.map(({ title, key, description, url }) => (
            <CardBase key={key} href={getAbsoluteUrl(url, pageConfig)}>
              <Card.Body>
                <Card.Copy>
                  <Card.Headline>{title}</Card.Headline>
                  <Card.Description variant="pLarge">{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="right">
                  <ChevronRightIcon />
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </ColumnTrack>
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 160px;
    }
  }
`

export default CardsSection
